<div class="astrea-box astrea-cart-item p-3 mb-3">
    <div class="grid-20-60-20">

        <div class="h-responsive">
            <a [routerLink]="['/book', book.bookcode]" title="{{ book.title }}">
                <img class="img-responsive" [src]="S3Service.getImageURL(book.image)" [appFallbackImg]="'/assets/images/default-book-cover.png'" alt="{{ book.title }}">
            </a>
        </div>

        <div class="d-flex flex-column j-c-between h-responsive p-0 p-sm-2">
            <div class="cart-item-info w-100">
                <div class="item-title pb-2">
                    <h2>{{ book.title }}</h2>
                    <p *ngIf="book.subtitle">
                        {{ book.subtitle }}
                    </p>
                </div>
                <div class="item-info-aside d-flex flex-column mt-2 mb-3">
                    <p *ngIf="book.bookType">
                        <strong>{{ 'books.details.type' | translate }}:</strong> {{ getBookType(book.bookType) }}
                    </p>
                    <p *ngIf="book.year">
                        <strong>{{ 'books.details.year' | translate }}:</strong> {{ book.year }}
                    </p>
                    <p *ngIf="book.edition">
                        <strong>{{ 'books.details.edition' | translate }}:</strong> {{ book.edition }}{{ fnService.getOrdinalNumber(book.edition) }}
                    </p>
                    <p *ngIf="book.pages">
                        <strong>{{ 'books.details.pages' | translate }}:</strong> {{ book.pages }}
                    </p>
                    <p *ngIf="book.bookFormat">
                        <strong>{{ 'books.details.format' | translate }}:</strong> {{ book.bookFormat }}
                    </p>
                    <p *ngIf="book.bookBinding">
                        <strong>{{ 'books.details.cover' | translate }}:</strong> {{ getBookBinding(book.bookBinding) }}
                    </p>
                </div>
            </div>
            <div class="d-flex j-c-center j-c-sm-start a-i-center mb-3 mb-sm-0 w-100">
                <a [routerLink]="['/book', book.bookcode]" class="btn btn-green btn-details" title="{{ book.title }}" mat-button>
                    {{ 'see_details' | translate }}
                </a>
                <a (click)="handleDeleteItem()" class="btn-item-delete ml-3" mat-button>
                    {{ 'delete' | translate }}
                </a>
            </div>
        </div>

        <div class="d-flex flex-column j-c-between a-i-center cart-item-total h-responsive p-0 p-sm-2">
            <div class="item-format t-center w-100">
                <h4>
                    {{ 'cart.type' | translate }}
                </h4>
                <h5>
                    {{ cart.typeStorage == 'physical_book' ? ('cart.item.physical' | translate) : cart.typeStorage == 'digital_book' ? ('cart.item.digital' | translate) : '' }}
                </h5>
            </div>

            <div *ngIf="cart.typeStorage == 'physical_book'" class="t-center">
                <small>{{ 'cart.item.units' | translate }}:</small>
                <div class="cart-select-count">
                    <button (click)="handleCountBooks(count-1)" mat-button>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <span class="counter px-2">{{ count }}</span>
                    <button (click)="handleCountBooks(count+1)" mat-button>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <div *ngIf="cart.typeStorage == 'physical_book'" class="t-center">
                <small>
                    {{ 'cart.item.units_price' | translate }}: <strong>{{ pricingService.getCurrency() }}{{ unitPrice }}</strong>
                </small>
            </div>

            <div *ngIf="cart.typeStorage == 'digital_book'" class="cart-handler t-center">
                <small>{{ 'cart.item.months' | translate }}:</small>
                <div class="cart-select-count">
                    <button (click)="handleCountBooks(count-1)" mat-button>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <span class="counter px-2">{{ count }}</span>
                    <button (click)="handleCountBooks(count+1)" mat-button>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <div *ngIf="cart.typeStorage == 'digital_book'" class="t-center">
                <small>
                    {{ 'cart.item.months_price' | translate }}: <strong>{{ pricingService.getCurrency() }}{{ unitPrice }}</strong>
                    <br>
                    <small>({{ 'books.min_months' | translate }})</small>
                </small>
            </div>

            <div class="t-center">
                <p>{{ 'cart.subtotal' | translate }}: <strong>{{ pricingService.getCurrency() }}{{ finalPrice }}</strong></p>
            </div>
        </div>

    </div>
</div>
